import React from "react";
import img from "../../assets/booked.png";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsCalendarDate } from "react-icons/bs";
import { FaCheckCircle, FaCalendarCheck, FaHospital, FaArrowRight } from "react-icons/fa";
import Button from "../../components/Button/Button";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function BookedAppointment() {
    const store = useSelector(state => state.bookAppontment)
    const appointment = useLocation().state.data;

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
            {/* Success Container */}
            <div className="flex flex-col items-center justify-center px-4 py-8 sm:px-6 lg:px-8">
                
                {/* Success Icon & Image */}
                <div className="relative mb-8">
                    <div className="relative">
                        <img 
                            src={img} 
                            alt="Appointment Booked Successfully" 
                            className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 object-contain"
                        />
                        <div className="absolute -top-2 -right-2 bg-green-500 rounded-full p-2 shadow-lg">
                            <FaCheckCircle className="text-white text-xl sm:text-2xl" />
                        </div>
                    </div>
                </div>

                {/* Success Message */}
                <div className="text-center mb-8 max-w-md">
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                        Congratulations!
                    </h1>
                    <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
                        You have successfully booked an appointment with{" "}
                        <span className="font-semibold text-primary100">{appointment.clinic_name}</span>
                    </p>
                </div>

                {/* Appointment Details Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8 w-full max-w-md">
                    
                    {/* Date Card */}
                    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 transform hover:scale-105 transition-all duration-300">
                        <div className="flex flex-col items-center">
                            <div className="bg-primary100 bg-opacity-10 rounded-full p-4 mb-4">
                                <BsCalendarDate className="text-primary100 text-2xl sm:text-3xl" />
                            </div>
                            <div className="text-center">
                                <p className="text-gray-500 text-sm font-medium mb-1">Appointment Date</p>
                                <p className="text-primary100 font-bold text-lg sm:text-xl">
                                    {appointment.appt_date}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Time Card */}
                    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 transform hover:scale-105 transition-all duration-300">
                        <div className="flex flex-col items-center">
                            <div className="bg-primary100 bg-opacity-10 rounded-full p-4 mb-4">
                                <AiOutlineClockCircle className="text-primary100 text-2xl sm:text-3xl" />
                            </div>
                            <div className="text-center">
                                <p className="text-gray-500 text-sm font-medium mb-1">Appointment Time</p>
                                <p className="text-primary100 font-bold text-lg sm:text-xl">
                                    {appointment.appt_time}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Info Card */}
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 mb-8 w-full max-w-md">
                    <div className="flex items-center justify-center space-x-3">
                        <FaHospital className="text-primary100 text-xl" />
                        <div className="text-center">
                            <p className="text-gray-500 text-sm font-medium">Clinic</p>
                            <p className="text-gray-800 font-semibold">{appointment.clinic_name}</p>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md">
                    <Link to={'/appointment'} className="flex-1">
                        <Button
                            text={"View My Appointments"}
                            textColor={"text-white"}
                            bg={"bg-primary100"}
                            width={"full"}
                        />
                    </Link>
                </div>

                {/* Quick Actions */}
                <div className="mt-8 text-center">
                    <p className="text-gray-500 text-sm mb-4">What would you like to do next?</p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <Link 
                            to="/first-appointment" 
                            className="flex items-center justify-center space-x-2 text-primary100 hover:text-primary100 transition-colors duration-200"
                        >
                            <FaCalendarCheck className="text-sm" />
                            <span className="text-sm font-medium">Book Another Appointment</span>
                            <FaArrowRight className="text-xs" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
